
(() => {

  /* ==================================================
   INIT DEFAULT PRICE (FIRST COLOR + SIZE)
================================================== */
function initDefaultVariantPrice() {
  document.querySelectorAll('.rpvs__item-group').forEach(group => {
    const variants = getVariants(group);
    if (!variants.length) return;

    // first available variant
    const first = variants.find(v => v.available);
    if (!first) return;

    /* set image */
    const img = group.querySelector('.rpvs-main-image');
    if (img && first.image) {
      img.src = first.image;
    }

    /* set price */
    const priceEl = group.querySelector('.rpvs-price-value');
    if (priceEl) {
      priceEl.textContent = formatMoney(first.price);
    }

    /* mark default color active */
    const colorBtn = group.querySelector(
      `.rpvs-color-btn[data-color="${first.color}"]`
    );
    if (colorBtn) {
      colorBtn.classList.add('active');
      group.dataset.color = first.color;
    }

    /* enable / disable sizes */
    group.querySelectorAll('.rpvs-size-btn').forEach(btn => {
      const match = variants.find(v =>
        v.color === first.color &&
        v.size === btn.dataset.size &&
        v.available
      );
      btn.disabled = !match;
      btn.classList.toggle('unavailable', !match);
    });
  });
}


  /* ==================================================
     PRICE FORMATTER
  ================================================== */
  function formatMoney(cents) {
    if (!cents) return '';
    return 'Rs. ' + (cents / 100).toFixed(0);
  }

  /* =====================================
     HELPERS
  ===================================== */
  function getVariants(group) {
    const el = group.querySelector('.rpvs-variant-map');
    if (!el) return [];

    return el.value.split('||').filter(Boolean).map(row => {
      const [id, color, size, image, available, price] = row.split('::');
      return {
        id,
        color,
        size,
        image,
        available: available === 'true',
          price: parseInt(price, 10)
      };
    });
  }

  function updateSubmitState() {
    const btn = document.querySelector('.product-form__submit');
    if (!btn) return;

    const mainVariant =
      document.querySelector('.product-form [name="id"]')?.value;

    const allRpvsInputs =
      document.querySelectorAll('.rpvs-selected-variant');

    const allSelected =
      [...allRpvsInputs].every(i => i.value);

    btn.disabled = !(mainVariant && allSelected);

    console.log('[STATE]', {
      mainVariant,
      rpvsVariants: [...allRpvsInputs].map(i => i.value),
      ready: !btn.disabled
    });
  }

  /* =====================================
     INIT
  ===================================== */
  document.addEventListener('DOMContentLoaded', updateSubmitState);

  /* =====================================
     COLOR CLICK
     (IMAGE + SIZE AVAILABILITY)
  ===================================== */
  document.addEventListener('click', e => {
    if (!e.target.classList.contains('rpvs-color-btn')) return;

    const group = e.target.closest('.rpvs__item-group');
    const color = e.target.dataset.color;
    const variants = getVariants(group);

    group.dataset.color = color;

    group.querySelectorAll('.rpvs-color-btn')
      .forEach(b => b.classList.remove('active'));
    e.target.classList.add('active');

    group.querySelectorAll('.rpvs-size-btn').forEach(btn => {
      const match = variants.find(v =>
        v.color === color &&
        v.size === btn.dataset.size &&
        v.available
      );
      btn.disabled = !match;
    });

    const first = variants.find(v => v.color === color && v.available);
    if (first) {
      group.querySelector('.rpvs-main-image').src = first.image;
    }
  });

  /* =====================================
     SIZE CLICK → SET HIDDEN INPUT VALUE
  ===================================== */
  document.addEventListener('click', e => {
    if (!e.target.classList.contains('rpvs-size-btn')) return;
    if (e.target.disabled) return;

    const group = e.target.closest('.rpvs__item-group');
    if (!group.dataset.color) {
      alert('Please select color first');
      return;
    }

    const variant = getVariants(group).find(v =>
      v.color === group.dataset.color &&
      v.size === e.target.dataset.size &&
      v.available
    );

    if (!variant) return;

    group.querySelectorAll('.rpvs-size-btn')
      .forEach(b => b.classList.remove('active'));
    e.target.classList.add('active');

    /* 🔑 SET INPUT VALUE */
    const input = group.querySelector('.rpvs-selected-variant');
    if (input) {
      input.value = variant.id;
      console.log('[INPUT SET]', variant.id);
    }

    updateSubmitState();
  });

  /* =====================================
     MAIN PRODUCT VARIANT CHANGE
  ===================================== */
  document.addEventListener('change', e => {
    if (
      e.target.name === 'id' ||
      e.target.closest('variant-selects') ||
      e.target.closest('variant-radios')
    ) {
      updateSubmitState();
    }
  });

  /* =====================================
     ADD TO CART (BUTTON CLICK OVERRIDE)
  ===================================== */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.product-form__submit');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.disabled) {
      console.warn('[BLOCKED] Variants missing');
      return;
    }

    const mainVariant =
      document.querySelector('.product-form [name="id"]')?.value;

    const rpvsInputs =
      document.querySelectorAll('.rpvs-selected-variant');

    const items = [
      { id: mainVariant, quantity: 1 }
    ];

    rpvsInputs.forEach(input => {
      if (input.value) {
        items.push({ id: input.value, quantity: 1 });
      }
    });

    console.log('🔥 FINAL ADD TO CART PAYLOAD', items);

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    const data = await res.json();
    const parser = new DOMParser();

    document.querySelector('cart-drawer')
      ?.replaceWith(
        parser.parseFromString(data['cart-drawer'], 'text/html')
          .querySelector('cart-drawer')
      );

   

    document.querySelector('cart-drawer')?.open();
     function initializeCartDrawerSlider() {
              $('.cart-drawer__collection').slick({
                slidesToShow: 2.5,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: false,
                autoplay: false,
                centerMode: false,
                centerPadding: '0px'
              });
            }
            
            initializeCartDrawerSlider();

    console.log('✅ ALL INPUT VARIANTS ADDED');

  }, true);

   document.addEventListener('DOMContentLoaded', initDefaultVariantPrice);
   window.addEventListener('load', initDefaultVariantPrice);
})();

